<template>
    <td>
        <v-chip class="mr-2" v-for="role in roles" :key="role">{{role}}</v-chip>
        <v-chip v-if="value.length > displayCount">+ {{value.length - displayCount}}</v-chip>
    </td>
</template>
<script>
export default {
    props: {
        value: { required: true },
        displayCount: { required: true }
    },
    computed: {
        roles() {
            return this.value.slice(0, this.displayCount);
        }
    }
};
</script>
